import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Linkedin } from 'lucide-react';
import { posts } from '../data/posts';
export function BlogPost() {
  const {
    id
  } = useParams();
  const post = posts.find(p => p.id === id);
  if (!post) {
    return <Navigate to="/blog" replace data-id="element-103" />;
  }
  return <article className="bg-white min-h-screen pb-24" data-id="element-104">
      {/* Hero Image */}
      <div className="w-full h-[40vh] md:h-[50vh] relative overflow-hidden" data-id="element-105">
        <div className="absolute inset-0 bg-[#4A3B47]/20 z-10" data-id="element-106" />
        <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-107" />
      </div>

      <div className="max-w-3xl mx-auto px-6 -mt-20 relative z-20" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-[#4A3B47]/5" data-id="element-109">
          <Link to="/blog" className="inline-flex items-center text-[#A88B9D] hover:text-[#4A3B47] transition-colors mb-8 font-medium" data-id="element-110">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-111" /> Back to Articles
          </Link>

          <div className="flex items-center gap-4 mb-6 text-sm" data-id="element-112">
            <span className="bg-[#F5F0F3] text-[#4A3B47] px-3 py-1 rounded-full font-medium" data-id="element-113">
              {post.category}
            </span>
            <span className="text-[#4A3B47]/60" data-id="element-114">{post.date}</span>
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#4A3B47] mb-8 leading-tight" data-id="element-115">
            {post.title}
          </h1>

          <div className="prose prose-lg prose-slate max-w-none" data-id="element-116">
            {post.content.split('\n\n').map((paragraph, index) => <p key={index} className="text-[#4A3B47]/80 leading-relaxed mb-6" data-id="element-117">
                {paragraph}
              </p>)}
          </div>

          {post.contentImage && <div className="mt-10 -mx-4 md:-mx-8" data-id="element-118">
              <img src={post.contentImage} alt={`Illustration for ${post.title}`} className="w-full rounded-2xl shadow-lg" data-id="element-119" />
            </div>}

          <div className="mt-12 pt-8 border-t border-[#4A3B47]/10 flex items-center justify-between" data-id="element-120">
            <p className="text-[#4A3B47]/60 italic" data-id="element-121">
              Originally published on LinkedIn
            </p>
            <a href={post.linkedinUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#0077b5] hover:underline font-medium" data-id="element-122">
              <Linkedin className="w-5 h-5" data-id="element-123" />
              View original post
            </a>
          </div>
        </motion.div>
      </div>
    </article>;
}